import { QrCode } from 'lucide-react';

export default function QrUpload({ onFileSelect }) {
  return (
    <div 
      className="mx-4 mt-4 relative bg-gray-100 rounded-2xl overflow-hidden border-4 border-white shadow-sm h-[280px] cursor-pointer active:scale-[0.98] transition-transform"
      onClick={onFileSelect}
      role="button"
      tabIndex={0}
      aria-label="Sélectionner une image de QR code"
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onFileSelect(); }}
    >
      <div className="absolute top-4 left-4 w-8 h-8 border-t-[3px] border-l-[3px] border-brand-navy rounded-tl-lg" />
      <div className="absolute top-4 right-4 w-8 h-8 border-t-[3px] border-r-[3px] border-brand-navy rounded-tr-lg" />
      <div className="absolute bottom-4 left-4 w-8 h-8 border-b-[3px] border-l-[3px] border-brand-navy rounded-bl-lg" />
      <div className="absolute bottom-4 right-4 w-8 h-8 border-b-[3px] border-r-[3px] border-brand-navy rounded-br-lg" />
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <QrCode className="w-14 h-14 text-brand-navy" strokeWidth={2.2} />
        <p className="text-brand-navy text-lg mt-3 font-bold">Appuyez pour importer</p>
        <p className="text-brand-navy/60 text-sm mt-1">ou utilisez les boutons ci-dessus</p>
      </div>
      <div className="absolute left-0 right-0 h-0.5 bg-accent-blue/60 animate-[scan_2s_ease-in-out_infinite]" style={{ top: '50%' }} />
    </div>
  );
}
